import { Api } from '../../services/http/Api';
import { Basket } from '../../types/basket/Basket';
import { ProductBasket } from '../../types/basket/ProductBasket';
import { throwIfGenericApiError } from '../GenericErrors';

export type CreateBasketPayload = {
  code: string;
  name: string;
  products: ProductBasket[];
  allowModelSelector: boolean;
};

class BasketDatasource {
  protected path = 'basket';

  async createBasket(payload: CreateBasketPayload): Promise<void> {
    const response = await new Api().post(`${this.path}/`, payload);
    throwIfGenericApiError(response);
  }

  async updateBasket(
    basketId: number,
    payload: CreateBasketPayload
  ): Promise<void> {
    const response = await new Api().put(`${this.path}/${basketId}`, payload);
    throwIfGenericApiError(response);
  }

  async getById(id: number): Promise<Basket> {
    const response = await new Api().fetch(`${this.path}/${id}`);
    throwIfGenericApiError(response);
    return response as Basket;
  }

  async getAll(): Promise<Basket[]> {
    const response = await new Api().fetch(this.path);
    throwIfGenericApiError(response);
    if (!Array.isArray(response)) {
      throw new Error('A resposta da consulta de balaios está inválida.');
    }
    return response as Basket[];
  }

  // async put(item: Basket): Promise<Basket> {
  //   return (await new Api().put(this.path, item)) as Basket;
  // }

  async delete(id: number): Promise<void> {
    const response = await new Api().delete(`${this.path}/${id}`);
    throwIfGenericApiError(response);
  }
}

export const BasketsDataSource = new BasketDatasource();
